import type { ShopCurrency } from "@/shared/lib/currency";
import { isShopCurrency } from "@/shared/lib/currency";
import { convertShopCurrencyAmount } from "@/shared/lib/exchange-rate";

/** ອັດຕາ 1 ຫົວໜ່ວຍ from → to (ບໍ່ມີຄືນ null) */
export function posFxOneUnitTo(
  from: ShopCurrency,
  to: ShopCurrency,
  rateMap: ReadonlyMap<string, number>,
): number | null {
  if (from === to) return 1;
  const conv = convertShopCurrencyAmount(1, from, to, rateMap);
  return conv != null ? conv.convertedAmount : null;
}

/** ຂໍ້ຄວາມສັ້ນ: 1 THB ≈ 350 LAK */
export function formatPosFxRateLine(
  from: ShopCurrency,
  to: ShopCurrency,
  rateMap: ReadonlyMap<string, number>,
): string | null {
  if (from === to) return null;
  const n = posFxOneUnitTo(from, to, rateMap);
  if (n == null) return null;
  const decimals = to === "LAK" ? 0 : 2;
  const formatted = n.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `1 ${from} ≈ ${formatted} ${to}`;
}

/** ສຳລັບເລືອກສະກຸນບິນ — ສະແດງອັດຕາຈາກສະກຸນໃນກະຕ່າໄປ option */
export function formatInvoiceCurrencyOptionHint(
  optionCurrency: ShopCurrency,
  cartCurrencies: string[],
  rateMap: ReadonlyMap<string, number>,
): string {
  const sources = [
    ...new Set(
      cartCurrencies.filter((c): c is ShopCurrency => isShopCurrency(c)),
    ),
  ];
  const parts = sources
    .filter((from) => from !== optionCurrency)
    .map((from) => formatPosFxRateLine(from, optionCurrency, rateMap))
    .filter((x): x is string => x != null);
  return parts.join(" · ");
}
